<div class="container">
  <div class="row justify-content-center my-5">
    <div class="col-lg-6 text-center">
      @if (isLoading) {
        <agmo-loading></agmo-loading>
      }
      @if (!isLoading && accountSetupPending) {
        <h2 class="font-weight-extrabold mb-4">You're verified!</h2>
        <div>The account setup page is still being built. Please check back soon.</div>
      }
      @if (!isLoading && errorMessage) {
        <h2 class="font-weight-extrabold mb-4">Unable to activate</h2>
        <div>{{ errorMessage }}</div>
      }
    </div>
  </div>
</div>
